<!-- //
ftp列表管理
@auth xuyd
@date 2025-07-20
//-->
<template>
  <page-layout layout="C" style="height: 500px;min-height: 500px;">
    <!-- 检索区域 -->
    <form-title title="FTP服务器" background-color="#d1d1d1" font-color="#333"/>
    <div class="layout-result" style="height: 100%;">
      <div class="layout-function" style="justify-content: space-between;align-items: center;margin-bottom: 5px;">
        <el-form @submit.native.prevent ref="refQueryForm" :model="queryParams" size="small" :inline="true"
                 label-width="100px">
          <el-form-item prop="search">
            <el-input
                v-model="queryParams.search"
                placeholder="请输入节点code/节点名称/ip检索ftp服务器"
                style="width: 320px;text-align: right;"
                maxlength="20"
                clearable
                @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="handleQuery" icon="el-icon-search">检索</el-button>
            <el-button size="small" type="primary" plain @click="handleReset" icon="el-icon-refresh">重置</el-button>
          </el-form-item>
        </el-form>
        <div style="display:flex; justify-content: right;">
          <el-button size="small" type="primary" @click="handleAdd" icon="el-icon-plus">添加</el-button>
        </div>
      </div>

      <DynamicTable :query-params="queryParams"
                    :selection="true"
                    :data="tableData"
                    :metas="tableMetas"
                    @reload="getList">
        <div slot-scope="{row, item}">
          <el-button size="small" type="text" @click="handleEdit(row)">编辑</el-button>
          <el-button size="small" type="text" @click="handleCopy(row)">复制</el-button>
          <el-button size="small" type="text" @click="handleDelete(row)">删除</el-button>
        </div>
      </DynamicTable>
    </div>
    <FtpDetail ref="refFtpDetail"/>
  </page-layout>
</template>

<script>
import RemoteFtpApi from '@/api/sys/sysRemoteFtp.api.js';
import FtpDetail from './ftp-detail';

export default {
  name: 'ViewRemoteFtpList',
  components: {FtpDetail},
  dictTypes: [
    {dictType: 'YES_OR_NO', dataType: Number},
    {dictType: 'ENV_TYPE', dataType: String},
  ],
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        orderByColumn: null,
        isAsc: null,
        search: null,
      },
      tableData: {
        tableLoading: false,
        records: [],
        total: 0,
      },
      tableMetas: [
        {prop: 'envType', label: "环境", width: 80, dataType: 'dict', dictType: 'ENV_TYPE'},
        {prop: 'nodeCode', label: "节点code", width: 120},
        {prop: 'nodeName', label: "节点名称", minWidth: 120},
        {prop: 'ip', label: "IP地址", width: 100, sortable: true},
        {prop: 'port', label: "端口", width: 80},
        {prop: 'username', label: "用户名", width: 100},
        {prop: 'status', label: "上线状态", width: 80, dataType: 'dict', dictType: 'YES_OR_NO'},
        {prop: 'rootPath', label: "根目录", minWidth: 120},
        {prop: 'maxTotal', label: "最大<br/>连接数", width: 80},
        {prop: 'maxIdle', label: "最大空闲<br/>连接数", width: 80},
        {prop: 'minIdle', label: "最小空闲<br/>连接数", width: 80},
        {prop: '', label: "操作", width: 150, fixed: 'right'},
      ]
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      RemoteFtpApi.selectFtpList(this.queryParams).then(resp => {
        this.tableData.records = resp.data;
      })
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },

    handleReset() {
      this.resetForm("refQueryForm");
      this.$refs.refQueryForm.resetFields();
      this.queryParams.orderByColumn = null;
      this.queryParams.isAsc = null;

      // =========重置(S)========
      // =========重置(E)========
      this.handleQuery();
    },

    /** 排序触发事件 */
    handleSortChange(column) {
      // console.log("----handleSortChange---->", JSON.stringify(column));
      if (column.order === 'ascending') {
        this.queryParams.isAsc = true;
        this.queryParams.orderByColumn = column.prop;
      } else if (column.order === 'descending') {
        this.queryParams.isAsc = false;
        this.queryParams.orderByColumn = column.prop;
      } else {
        this.queryParams.isAsc = null;
        this.queryParams.orderByColumn = null;
      }
      this.getList();
    },
    handleAdd() {
      this.$refs.refFtpDetail.showModal({
        data: {},
        onOk: (data) => {
          this.getList()
        }
      });
    },

    handleEdit(row) {
      this.$refs.refFtpDetail.showModal({
        mode: 2,
        title: '修改服务器',
        data: {...row},
        onOk: (data) => {
          this.getList()
        }
      });
    },
    handleCopy(row) {
      this.$refs.refFtpDetail.showModal({
        mode: 1,
        title: '新增服务器',
        data: {...row, id: null},
        onOk: (data) => {
          this.getList()
        }
      });
    },
    handleDelete(row) {
      this.$modal.confirm(`确定要删除【${row.ip}】吗？`).then(() => {
        RemoteFtpApi.deleteFtp(row.id).then(resp => {
          this.$modal.msgSuccess('删除成功');
          this.getList();
        })
      })
    },
  }
}
</script>

<style lang="less" scoped>

</style>
